<template>
  <div v-if="isMounted">
    <home-section id="home-section" currentPage="menu"></home-section>
    <div v-if="selectedLocation">
      <sub-menu-navbar style="height:43px" id="sub-menu-navbar" @buttonClicked="tabToDisplay"></sub-menu-navbar>
      <search-nav-bar id="search-bar"></search-nav-bar>
      <small-categories-section :categories="filteredData" :active-category="activeCategory"
        @setActiveCategory="onSetActiveCategory"></small-categories-section>
      <section class="section section-menu" id="menu-section">
        <div class="container">
          <div class="row">
            <categories-section ref="categogyParentElement" :categories="filteredData" :active-category="activeCategory"
              @setActiveCategory="onSetActiveCategory"></categories-section>
            <menu-section id="section-menu" :tabName="tab" :categories="filteredData" :favorites="filterFavoriteData"
              :specials="filtredSpecialData"></menu-section>
            <checkout-section :hide="true" :action="btnAction"></checkout-section>
          </div>
        </div>
      </section>
      <order-modal ref="itemModal" :fromItem="fromItem" :editMode="editMode" :index="index"
        :order-type="newCart.orderType">

        <order-item-option v-if="fromItem && fromItem.hasOptions" slot="item-options" :options="fromItem.options" :isDeliverect="newCart.is_deliverect" />
        <order-item-meal-deal-sections slot="item-meal-deal-sections" v-if="fromItem && fromItem.is_meal_deal"
          :order-type="newCart.orderType" :sections="fromItem.sections" :isDeliverect="newCart.is_deliverect"  />
      </order-modal>
      <order-changes-confirmation ref="popupConfirmation"></order-changes-confirmation>
    </div>
    <div v-else>
      <empty-data :message="$t('empty.no_location_selected')" icon="k-icon-home" iconColor="#738290"
        textColor="#22223B"></empty-data>
    </div>
  </div>
</template>
<script>
import { mapActions } from "vuex";
import {
  HomeSection,
  CategoriesSection,
  CheckoutSection,
  MenuSection,
  SmallCategoriesSection,
  EmptyData,
} from "@/views/components";
import { OrderModal } from "@/views/modals";
import { OrderItemOption, OrderItemMealDealSections } from "@/views/partial";
import { OrderChangesConfirmation } from "@/layout";
import {
  SubMenuNavbar,
  SearchNavBar
} from "@/layout";

import { cartManager } from "@/utilities";
import { $_find, filterBy, $_findSpecial } from "@/utilities/helper";
import { ACTIONS } from "@/utilities/enums"
import { orderingMixin } from "@/mixins";
export default {
  name: "location-menu",
  mixins: [orderingMixin],
  bodyClass: "menu-page",
  components: {
    HomeSection,
    SubMenuNavbar,
    CategoriesSection,
    CheckoutSection,
    MenuSection,
    OrderModal,
    SmallCategoriesSection,
    EmptyData,
    OrderChangesConfirmation,
    SearchNavBar,
    OrderItemOption,
    OrderItemMealDealSections
  },
  computed: {
    filteredData: function () {
      if (this.tab == "menu") {
        return $_find(
          this.locationMenuItems,
          this.searchTerm,
          this.tab,
          this.newCart.orderType,
          filterBy
        );
      }
      return null;
    },
    filterFavoriteData: function () {
      if (this.user && this.tab == "fav") {
        return $_find(
          this.locationMenuItems,
          this.searchTerm,
          this.tab,
          this.newCart.orderType,
          filterBy
        );
      }
      return null;
    },
    filtredSpecialData: function () {
      const { selectedLocation, searchTerm, tab, newCart } = this;
      if (tab == "menu") {
        return $_findSpecial(
          selectedLocation.specials,
          searchTerm,
          newCart.orderType
        );
      }
      return null;
    },
  },
  data() {
    return {
      fromItem: null,
      editMode: false,
      index: -1,
      tab: "menu",
      btnAction: ACTIONS.CHECKOUT,
      counterClick: 0,
      searchTerm: "",
      confirmedPopup: false,
      isMounted: false,
      continueProcessing: true,
      activeCategory: "special"
    };
  },
  methods: {
    ...mapActions('locationStore', ["fetchCategories"]),

    setPopupTrue() {
      this.confirmedPopup === true;
    },

    tabToDisplay: function (_tabName) {
      this.tab = _tabName;
    },
    searchEventListner: function () {
      this.$root.$off("SEARCH_ITEMS");
      this.$root.$on("SEARCH_ITEMS", (term) => {
        this.searchTerm = term;
      });
    },
    onSetActiveCategory(value) {
      this.$set(this, 'activeCategory', value)
    },
    forceComponentUpdate() {
      this.fetchCategories(this.selectedLocation.id)
      this.$nextTick(() => {
        this.$forceUpdate();
      })


    }
  },
  created() {

    this.addEventListener();
    this.removeEventListner();
    this.searchEventListner();
    this.openPopUpConfirmationEventListner();

    this.activeCategory = (this.filtredSpecialData && this.filtredSpecialData.length) ? "special" :
      this.locationMenuItems && this.locationMenuItems.length ? this.locationMenuItems[0].id : null;

    this.fetchCategories(this.selectedLocation.id);
    this.$root.$on('forceRefreshMenuSection', () => {
      this.forceComponentUpdate()
    })
  },
  mounted() {
    if (!this.selectedLocation) {
      this.$router.push({ name: 'home' })
    }
    this.refreshLocationData();
    this.isMounted = true;
    // if the cart is already saved , do not save-it
    this.setCartDeliveryFee().then((result) => {
      if (!result) cartManager.setCart(this.newCart, true, false);
    });

    //---- save the selected location id , in the cart

    this.newCart.locationId = this.selectedLocation.id;

    cartManager.setCart(this.newCart, false, false);

    this.applyCoupon();
  },
  beforeDestroy() {
    this.$root.$off('forceRefreshMenuSection')
  }

};
</script>
